// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "facf4ababc13880493c669aa53e6ce4a32e5b7c2/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};